import React from 'react'
import { Link } from 'react-router-dom'

export default function RoleSystemsHero({ volumeCount = 0 }) {
  const scrollUrl = `${process.env.PUBLIC_URL}/single_scroll.jpg`

  return (
    <header className="role-systems-hero">
      <div
        className="role-systems-hero__bg"
        style={{ backgroundImage: `url(${scrollUrl})` }}
        aria-hidden="true"
      />
      <div className="role-systems-hero__overlay" aria-hidden="true" />

      <div className="role-systems-hero__content">
        <div className="role-systems-hero__main">
          <div className="role-systems-hero__emblem" aria-hidden="true">
            制
          </div>
          <div className="role-systems-hero__text">
            <span className="role-systems-hero__eyebrow">制 · Códice</span>
            <h1 className="role-systems-hero__title">Sistemas de juego</h1>
            <p className="role-systems-hero__subtitle">
              Reglas, mecánicas y pautas OOC para jugar en Shinobis&apos; War. Solo verás los
              volúmenes a los que tu cuenta tiene acceso.
            </p>
          </div>
        </div>

        {volumeCount > 0 ? (
          <div className="role-systems-hero__kpi" aria-label={`${volumeCount} volúmenes disponibles`}>
            <span className="role-systems-hero__kpi-value">{volumeCount}</span>
            <span className="role-systems-hero__kpi-label">
              {volumeCount === 1 ? 'Volumen' : 'Volúmenes'}
            </span>
          </div>
        ) : null}

        <Link to="/" className="role-systems-hero__back">
          ← Volver al inicio
        </Link>
      </div>

      <div className="role-systems-hero__bottom-line" aria-hidden="true" />
    </header>
  )
}
